import styled from 'styled-components';

export default styled.div`
  transition: transform 0.3s ease-in-out;

  &.smartplayer__footer--visible {
    transform: translateY(0);
  }

  &.smartplayer__footer--hidden {
    transform: translateY(100px);
  }
`;
